module.exports = __webpack_public_path__ + "html/create-video-button_d323969e6e3f4fae4254968fbeeaf629.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/create-video-button.html
// module id = VkJ+
// module chunks = 118